


import InlineLoading from 'vux/src/components/inline-loading/index.vue'

import BScroll from "better-scroll";
export default {
components: { InlineLoading },
props: {
params: {

type: Object,
default: () => {
return {};
},
},
fixedHeight: {

type: String,
default: () => {
return null;
},
},
tipColor: {

type: String,
default: "#fff",
},
refresh: {

type: Boolean,
default: false,
},
load: {

type: Boolean,
default: true,
},
otherH: {

type: Number,
default: 0,
},
eleArray: {

type: Array,
default: () => {
return [];
},
},
onlyScroll: {

type: Boolean,
default: false,
},
},
data() {
return {
loadOptions: {
click: true,
scrollX: false,
scrollY: true, // 因为scrollY默认为true，其实可以省略
scrollbar: {
fade: false,
interactive: true,
},
mouseWheel: true,
pullDownRefresh: {
threshold: 50, // 当下拉到超过顶部 50px 时，触发 pullingDown 事件
stop: 40, // 刷新数据的过程中，回弹停留在距离顶部还有 20px 的位置
},
pullUpLoad: {
threshold: -50, // 在上拉到超过底部 20px 时，触发 pullingUp 事件
stop: 40,
moreTxt: "Load more",
noMoreTxt: "There is no more data",
},
},
IsdataLoaded: false,
loading: false,
topLoading: false,
bottomLoading: false,
loadType: null,
scroll: null,
resizeHandler: null,
};
},
watch: {
IsdataLoaded(v) {
if (v) {
console.log(v, this.scroll);
this.$nextTick(() => {
let $inputs = document.querySelectorAll(".EuropeInput input");
if ($inputs.length > 0) {
for (let i = 0; i < $inputs.length; i++) {
this.listenKeybord($inputs[i]);
}
}
});
}
},
},
created() {},
mounted() {
this.$nextTick(() => {
let timer = setTimeout(() => {
this.initScroll();
this.handleScroll();
clearTimeout(timer);
}, 100);
window.addEventListener("resize", this.handleScroll);
});
},
methods: {
_scroll() {
window.addEventListener("scroll", () => {
if (
(document.documentElement.scrollTop || document.body.scrollTop) -
document.querySelector(".game-nav").offsetTop >
-5
) {
console.log("----------------------------");
console.log(
document.documentElement.scrollTop || document.body.scrollTop
);
console.log(document.querySelector(".game-nav").offsetTop);
}
});
},
handleScroll() {
let billBox = document.querySelector(".Load-more-warp");
if (!this.fixedHeight) {
const body = document.querySelector("body");
let height = this.getCss(body, "height");
let clientHeight = document.documentElement.clientHeight;
let offsetTop = billBox.offsetTop;
let ArrayTotalH = 0;
this.eleArray.forEach((item) => {
if (document.querySelector(`${item}`))
ArrayTotalH =
ArrayTotalH + document.querySelector(`${item}`).offsetHeight;

});
if (!clientHeight) {
height =
ArrayTotalH > 0
? height - ArrayTotalH - this.otherH
: height - offsetTop - this.otherH;
} else {
height =
ArrayTotalH > 0
? clientHeight - ArrayTotalH - this.otherH
: clientHeight - offsetTop - this.otherH;
}

} else {

}
},
activeElementScrollIntoView(activeElement, delay) {
var editable = activeElement.getAttribute("contenteditable");


if (
activeElement.tagName == "INPUT" ||
activeElement.tagName == "TEXTAREA" ||
editable === "" ||
editable
) {
setTimeout(function () {
activeElement.scrollIntoView();
}, delay);
}
},

judgeDeviceType() {
var ua = window.navigator.userAgent.toLocaleLowerCase();
var isIOS = /iphone|ipad|ipod/.test(ua);
var isAndroid = /android/.test(ua);

return {
isIOS: isIOS,
isAndroid: isAndroid,
};
},

listenKeybord($input) {
let judgeDeviceType = this.judgeDeviceType();
if (judgeDeviceType.isIOS) {

$input.addEventListener(
"focus",
function () {
console.log("IOS 键盘弹起啦！");

},
false
);


$input.addEventListener("blur", () => {
console.log("IOS 键盘收起啦！");

});
}


if (judgeDeviceType.isAndroid) {
const originHeight =
document.documentElement.clientHeight || document.body.clientHeight;
this.resizeHandler = () => {
const resizeHeight =
document.documentElement.clientHeight || document.body.clientHeight;
const activeElement = document.activeElement;
if (resizeHeight < originHeight) {

if (
activeElement &&
(activeElement.tagName === "INPUT" ||
activeElement.tagName === "TEXTAREA")
) {
setTimeout(() => {
activeElement.scrollIntoView({ block: "center" }); 
}, 0);
}
} else {

window.scrollTo(0, 0);
this.scroll.refresh();
}
};
window.addEventListener("resize", this.resizeHandler);
}
},
initScroll() {
this.loadOptions.pullUpLoad.moreTxt = this.$t("others.loadingTxt");
this.loadOptions.pullUpLoad.noMoreTxt = this.$t("others.noData1");
if (!this.refresh) this.loadOptions.pullDownRefresh = false;
if (!this.load) this.loadOptions.pullUpLoad = false;
this.scroll = new BScroll(this.$refs.LoadMore, this.loadOptions);
this.scroll.on("pullingDown", () => {
if (this.loading || this.onlyScroll) return; 
this.loading = true;
this.topLoading = true;
this.loadType = "refresh";
this.$emit(this.loadType, {
params: this.params,
finish: this.finish,
destroy: this._destroy,
});
});
this.scroll.on("pullingUp", () => {
if (this.loading || this.onlyScroll) return; 
this.loading = true;
this.bottomLoading = true;
this.loadType = "loadmore";
this.$emit(this.loadType, {
params: this.params,
finish: this.finish,
destroy: this._destroy,
});
});
},
finish() {
let timer = setTimeout(() => {
if (this.loadType === "refresh") {
this.topLoading = false;
this.scroll.finishPullDown();
this.scroll.refresh();
}
if (this.loadType === "loadmore") {
this.bottomLoading = false;
this.scroll.finishPullUp();
this.scroll.refresh();
}
this.loadType = null;
this.loading = false;
clearTimeout(timer);
}, 500);
},
getCss(curEle, attr) {
let val = null,
reg = null;
if ("getComputedStyle" in window) {
val = window.getComputedStyle(curEle, null)[attr];
} else {
val = curEle.currentStyle[attr];
}
reg = /^(-?\d+(\.\d+)?)(px|pt|rem|em)?$/i;
return reg.test(val) ? parseFloat(val) : val;
},
_destroy() {
if (this.scroll) this.scroll.destroy();
},
scrollToTop() {

console.log("返回顶部");
if (this.scroll) this.scroll.scrollTo(0, 0, 500);
},
scrollToBottom() {

if (this.scroll) this.scroll.scrollTo(0, this.scroll.maxScrollY, 500);
},
dataLoaded() {

this.IsdataLoaded = true;
},
},
destroyed() {
this._destroy();
window.removeEventListener("resize", this.handleScroll);
window.removeEventListener("resize", this.resizeHandler);
},
};



// WEBPACK FOOTER //
// ./src/common/components/load-more/index.vue